/* eslint-disable comma-dangle */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CheckOutlined, CopyOutlined, DownOutlined, StopOutlined } from '@ant-design/icons';
import { Input, Tooltip, Card, Dropdown, Menu, Button, Form, Space } from 'antd';
import { getApp } from '@store/admin/apps/selectors';
import { update as updateApp } from '@store/admin/apps/actions';
import PageHeader from '@components/common/PageHeader';
import { singleAppPrefix } from '../../../routers';

const ApplicationEdit = ({ app, update }) => {
  const deactivate = (x) => update({ ...x, inactive: true });
  const activate = (x) => update({ ...x, inactive: false });
  const [editingGeneralSettings, setEditingGeneralSettings] = useState(false);
  const [editingClientCredential, setEditingClientCredential] = useState(false);

  const { title, description, clientId, clientSecret } = app;

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 4,
      },
    },
  };

  const handleGeneralSettingSubmit = (values) => {
    update({ ...app, ...values }, () => {
      setEditingGeneralSettings(false);
    });
  };

  const handleCredentialSubmit = (values) => {
    update({ ...app, ...values, clientSecret: '' }, () => {
      setEditingClientCredential(false);
    });
  };

  const onActivate = () => {
    deactivate(app);
  };

  const onDeactivate = () => {
    activate(app);
  };

  const onEditSettings = () => {
    setEditingGeneralSettings((status) => !status);
  };

  const onEditCredentials = () => {
    setEditingClientCredential((status) => !status);
  };

  return (
    <div>
      <PageHeader
        style={{
          marginTop: '5px',
          marginLeft: '1px',
          backgroundColor: 'white',
        }}
        title={app.title}
        back={<Link to={`${singleAppPrefix}/manage/apps/list`}>Applications</Link>}
        extra={[
          <Dropdown
            key="1"
            overlay={
              <Menu>
                {!app.inactive && (
                  <Menu.Item onClick={onActivate}>
                    <Space>
                      <StopOutlined />
                      <span>Deactivate</span>
                    </Space>
                  </Menu.Item>
                )}
                {app.inactive && (
                  <Menu.Item onClick={onDeactivate}>
                    <Space>
                      <CheckOutlined />
                      <span>Activate</span>
                    </Space>
                  </Menu.Item>
                )}
              </Menu>
            }
          >
            <Button>
              {app.inactive ? <span>Inactive</span> : <span>Active</span>}
              <DownOutlined />
            </Button>
          </Dropdown>,
        ]}
      />
      <Card
        title="General Settings"
        extra={
          <Button onClick={onEditSettings}>{editingGeneralSettings ? 'Cancel' : 'Edit'}</Button>
        }
      >
        <Form
          {...formItemLayout}
          onFinish={handleGeneralSettingSubmit}
          initialValues={{ title, description }}
        >
          <Form.Item
            label="Title"
            name="title"
            rules={[
              {
                required: true,
                message: 'Please input your application title',
              },
            ]}
          >
            <Input disabled={!editingGeneralSettings} />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input.TextArea disabled={!editingGeneralSettings} />
          </Form.Item>
          {editingGeneralSettings && (
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          )}
        </Form>
      </Card>

      <Card
        title="Client Credential"
        extra={
          <Button onClick={onEditCredentials}>{editingClientCredential ? 'Cancel' : 'Edit'}</Button>
        }
      >
        <Form
          {...formItemLayout}
          onFinish={handleCredentialSubmit}
          initialValues={{ clientId, clientSecret }}
        >
          <Form.Item
            label="Client ID"
            name="clientId"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              disabled
              addonAfter={
                <Tooltip title="Copy to clipboard">
                  <CopyToClipboard text={app.clientId}>
                    <CopyOutlined style={{ lineHeight: 1 }} />
                  </CopyToClipboard>
                </Tooltip>
              }
            />
          </Form.Item>
          <Form.Item
            label="Client Secret"
            name="clientSecret"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input
              type="password"
              disabled
              addonAfter={
                <Tooltip title="Copy to clipboard">
                  <CopyToClipboard text={app.clientSecret}>
                    <CopyOutlined style={{ lineHeight: 1 }} />
                  </CopyToClipboard>
                </Tooltip>
              }
            />
          </Form.Item>
          {editingClientCredential && (
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                Generate New Client Secret
              </Button>
            </Form.Item>
          )}
        </Form>
      </Card>
    </div>
  );
};

ApplicationEdit.defaultProps = {
  app: {
    title: '',
    clientId: '',
    clientSecret: '',
    inactive: false,
  },
};

const mapStateToProps = (state, { match }) => ({
  app: getApp(state, match),
});

export default withRouter(
  connect(mapStateToProps, {
    update: updateApp,
  })(ApplicationEdit),
);
